/* eslint-disable react/jsx-key */
import React from 'react';
import PropTypes from 'prop-types';
import { useTable, useSortBy, usePagination, useFilters } from 'react-table';

import { TableBody } from './TableBody';
import { StatsTable } from '../../../../../statspro/js/components/common/stats-table/StatsTable';
import { NextPageButton } from '../../../../../statspro/js/components/common/stats-table/NextPageButton';
import { StatsTableHead } from '../../../../../statspro/js/components/common/stats-table/StatsTableHead';

const PAGE_SIZE = 15;
export const Table = ({ columns, data, modifier, cssClass }) => {
    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        rows,
        prepareRow,
        page,
        canNextPage,
        setPageSize,
        state: { pageSize }
    } = useTable(
        {
            columns,
            data,
            initialState: {
                // @ts-ignore
                pageSize: PAGE_SIZE
            }
        },
        useFilters,
        useSortBy,
        usePagination
    );

    // ===== Render ========================================================= //

    return (
        <StatsTable
            modifier={modifier}
            getTableProps={getTableProps}
            cssClass={cssClass}
            stickyHeader={<StatsTableHead headerGroup={headerGroups[0]} />}
            nextPageButton={
                <NextPageButton
                    canNextPage={canNextPage}
                    currentPageSize={pageSize}
                    pageSize={PAGE_SIZE}
                    totalRowCount={rows.length}
                    setPageSize={setPageSize}
                    customLabel={'label.draftTracker.paginationNext'}
                />
            }
        >
            <StatsTableHead headerGroup={headerGroups[0]} />
            <TableBody
                rows={page}
                prepareRow={prepareRow}
                getTableBodyProps={getTableBodyProps}
            />
        </StatsTable>
    );
};

Table.propTypes = {
    columns: PropTypes.array.isRequired,
    data: PropTypes.array.isRequired,
    modifier: PropTypes.string,
    cssClass: PropTypes.string
};
